export default {
  Short: 'Short',
  Simplified: 'Simplified',
  Specific: 'Specific',
};
